const VSC_MINIMUM_CUTOFF = Date.parse('2026-09-22T04:00:00Z')

export const vscMinimumNet = (timestamp) => {
    // Reports before the backend cutoff keep the former $25 VSC minimum.
    const normalizedTimestamp = typeof timestamp === 'string' && /^\d{4}-\d{2}-\d{2}[ T]\d{2}:\d{2}(?::\d{2}(?:\.\d+)?)?$/.test(timestamp)
        ? `${timestamp.replace(' ', 'T')}Z`
        : timestamp
    const reportTime = timestamp == null ? NaN : new Date(normalizedTimestamp).getTime()
    return Number.isNaN(reportTime) || reportTime >= VSC_MINIMUM_CUTOFF ? 50 : 25
}

export const calculateContractCount = (contractType, net, timestamp) => {
    const type = contractType?.value ?? contractType
    if (String(type).includes('VSC')) {
        const minimum = vscMinimumNet(timestamp)
        return net >= minimum ? 1 : net / minimum
    }
    return net / 100
}
